import { Col, Form, Row, Typography } from "antd";
import {
  createStore,
  editStore,
} from "apps/Account/Pages/Institutional/Services";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";
import AddOrUpdateProfileImage from "apps/CustomerPanel/Profile/Components.tsx/AddOrUpdateImageProfile";
import useMazakaForm from "hooks/useMazakaForm";
import { useEffect, useState } from "react";
import {
  addImageByStore,
  getStoreDetails,
} from "../../Services";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import { useQueryClient } from "react-query";
import endPoints from "../../EndPoints"

const ShoppingInfos = (props: any) => {
  const queryClient = useQueryClient()
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [searchParasm, setSearchParams] = useSearchParams();
  const storeId = searchParasm.get("storeId");
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const [storeData, setStoreData] = useState<any>(null);
  const getStoreInfoes = async (storeId: string) => {
    try {
      const response = await getStoreDetails(storeId);
      if (response?.data) {
        let data = response?.data;
        form.setFieldsValue({
          storeName: data?.storeName,
          storeDescription: data?.storeDescription,
        });
        setStoreData({ ...data });
     
        if (data?.photoUrl?.length) {
          setFileList([
            {
              uid: "-1",
              name: "",
              status: "done",
              url: setBackEndUlr() + "/" + data?.photoUrl,
              preview: setBackEndUlr() + "/" + data?.photoUrl,
            },
          ]);
        }
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.log("Somethings wrong during getting store", error);
    }
  };
  useEffect(() => {
    if (storeId) {
      getStoreInfoes(storeId);
    }
  }, [storeId]);

 
  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    const formValues = form.getFieldsValue();
    formValues["userId"] = userInfoes?.id;
    formValues["kepAddress"] = "";

    if (storeId) {
      try {
        const response: any = await editStore({ ...storeData, ...formValues });
        if (fileList.length <= 0) {
          formValues["photoUrl"] = "";
        } 
        else {
          let image = { storeId, file: fileList[0]?.originFileObj || null };
        
           await addImageByStore(image);
        }
        if (response?.data) {
          setSearchParams({ storeId: response?.data?.id });
        }
        mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
      } catch (error: any) {
        mazakaForm.setFailed(2000, error?.message);
        console.log("Something wrong during saving store");
      }
    } else {
      try {
        const response: any = await createStore(formValues);
        if (response?.data) {
          if (fileList.length > 0) {
            let data = {
              storeId: response?.data?.id,
              file: fileList[0]?.originFileObj || null,
            };
            await addImageByStore(data);
          }
          setSearchParams({ storeId: response?.data?.id });
          setStoreData({...response?.data})
          mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
        }
      } catch (error: any) {
        mazakaForm.setFailed(2000, error?.message);
        console.log("Something wrong during saving store");
      }
    }
     
    
    


  };
  const { Text } = Typography;
  const [fileList, setFileList] = useState<any[]>([]);
  
  return (
    <>
      <Col span={24}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="!px-4">
            <Col span={24}>
              <AddOrUpdateProfileImage
                fileList={fileList}
                setFileList={setFileList}
                type="store"
              />
            </Col>

            <MazakaInput
              xs={24}
              name={"storeName"}
              label={"Mağaza Adı"}
              className="!m-0"
              inputClassName="!p-2"
              rules={[{ required: true, message: "" }]}
              placeholder={"Mağaza Adı"}
            />
            <MazakaTextArea
              xs={24}
              name={"storeDescription"}
              label={"Açıklama"}
              className="!m-0"
              placeholder={"Açıklama"}
            />

            <Col span={24} className="!flex gap-2">
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                processType={formActions.submitProcessType}
              >
                Kaydet
              </MazakaButton>
              {storeId && storeData && (
                <>
                  <MazakaButton
                    className="!p-4 !bg-black !text-white"
                    htmlType="submit"
                    onClick={()=>{
                          props.setCurrentStep(2);
                    }}
                  >
                    Devam Et
                  </MazakaButton>
                </>
              )}
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default ShoppingInfos;
